module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAV5JREFUOE+t1DFIAmEUB/D/O28QDLpV7gyE2hpa2hyChsYasxPyys01qFFoqbmWBhUizXBpaHBsqDEKamiM0FOw4MALNLp7cYGQ2nl35De/9/ve9973fYQJLZqQA08otwQxPiNPb5423sdtOhYqqPI+SNgBEGbwU8i20uly8+4v0BXKq7EsEY5/JzHzm/BhzmmXhjGMuUIFVbkH0cJwgm1byUxZr/iHUsojQPP/hoopZZdBB0OQQWYnHuhozrRisnwEUIaIRAbXYVnJ7fPmTaBm94OLa5KEcFjSKq2XwON3kjkSWQVRAsCsAzBgCIxngn2VLum3ns3OpxSVQM7YJbcKGFzr9npattpu9WMGxl/YiK5AEGu+ng3zw2ujvpi7xpcTPwi53B1XmK31rZJ+MQLlVaVDRFO+Kvqpgve0s/rhKJSMJoRQaNkPZDOZ3c/uSbbaNkcgP4BbjOc34hf/BqLkeBPirpuuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/witer.png
// module id = n3X4
// module chunks = 1